module.exports = __webpack_public_path__ + "img/edoras-3018-09-19.d79cf10a.jpg";